export const courses = [
  {
    id: 1,
    title: '기초반 (Level 1)',
    subtitle: 'Foundation Course · 1~4주차',
    badge: '입문',
    duration: '4주 · 16시간',
    desc: '색소학, 피부 이론, 위생 관리 등 전문가로서의 기초를 탄탄히 다지는 입문 과정입니다.',
    image: 'https://public.readdy.ai/ai/img_res/071f170b7bbd429f88cac55b800c9a79.jpg',
  },
  {
    id: 2,
    title: '심화반 (Level 2)',
    subtitle: 'Advanced Course · 5~8주차',
    badge: '심화',
    duration: '4주 · 16시간',
    desc: '실제 모델 실습을 통해 눈썹·아이라인·입술 반영구 기법을 집중 훈련하는 실전 과정입니다.',
    image: 'https://readdy.ai/api/search-image?query=intermediate%20beauty%20student%20practicing%20advanced%20semi-permanent%20makeup%20on%20model%2C%20professional%20studio%20environment%2C%20instructor%20supervising%2C%20detailed%20precision%20work%2C%20bright%20clean%20setting&width=600&height=400&seq=home_course2&orientation=landscape',
  },
  {
    id: 3,
    title: '마스터반 (Level 3)',
    subtitle: 'Master Course · 9~12주차',
    badge: '수료',
    duration: '4주 · 16시간',
    desc: '독립 실습과 포트폴리오 완성으로 현장 투입 가능한 전문가로 거듭나는 최종 완성 과정입니다.',
    image: 'https://readdy.ai/api/search-image?query=advanced%20beauty%20professional%20completing%20masterclass%20certification%2C%20confident%20skilled%20artist%20working%20independently%2C%20professional%20studio%2C%20polished%20final%20work%2C%20prestigious%20educational%20environment&width=600&height=400&seq=home_course3&orientation=landscape',
  },
];

export const stats = [
  { value: '1,200+', label: '누적 수료생' },
  { value: '98%', label: '자격증 취득률' },
  { value: '15년+', label: '교육 경력' },
  { value: '100%', label: '본회 공식 인증' },
];

export const galleryImages = [
  {
    id: 1,
    category: '반영구 문신',
    title: '자연 결 눈썹 반영구',
    image: 'https://readdy.ai/api/search-image?query=extreme%20close-up%20of%20Korean%20woman%20face%20showing%20beautifully%20shaped%20natural%20hair-stroke%20eyebrow%20semi-permanent%20tattoo%20result%2C%20fine%20individual%20hair-like%20strokes%2C%20perfectly%20arched%20brows%2C%20clean%20white%20studio%20background%2C%20professional%20Korean%20beauty%20clinic%20photography%2C%20soft%20diffused%20lighting%2C%20elegant%20refined%20look%2C%20high%20resolution%20detail&width=400&height=500&seq=gallery_brow1_v2&orientation=portrait',
  },
  {
    id: 2,
    category: '반영구 문신',
    title: '콤보 눈썹 반영구',
    image: 'https://readdy.ai/api/search-image?query=close-up%20portrait%20of%20young%20Korean%20woman%20with%20combo%20brow%20semi-permanent%20tattoo%20showing%20gradient%20powder%20shading%20blended%20with%20fine%20hair%20strokes%2C%20naturally%20defined%20full%20brows%2C%20clean%20bright%20white%20studio%20background%2C%20professional%20Korean%20aesthetic%20clinic%20photography%2C%20soft%20flattering%20beauty%20lighting%2C%20polished%20result&width=400&height=500&seq=gallery_brow2_v2&orientation=portrait',
  },
  {
    id: 3,
    category: '두피 반영구 문신',
    title: '두피 밀도 개선',
    image: 'https://readdy.ai/api/search-image?query=close-up%20of%20Korean%20man%20scalp%20top%20view%20showing%20scalp%20micropigmentation%20SMP%20result%20with%20realistic%20natural-looking%20hair%20follicle%20pigment%20dots%20evenly%20distributed%2C%20significantly%20improved%20hair%20density%20appearance%2C%20clean%20clinical%20white%20background%2C%20professional%20Korean%20medical%20aesthetic%20photography%2C%20sharp%20detailed%20close-up&width=400&height=500&seq=gallery_smp1_v2&orientation=portrait',
  },
  {
    id: 4,
    category: '입술 반영구 문신',
    title: '립 블러쉬',
    image: 'https://readdy.ai/api/search-image?query=extreme%20close-up%20of%20Korean%20woman%20lips%20showing%20lip%20blush%20semi-permanent%20tattoo%20result%20with%20soft%20natural%20rosy%20gradient%20ombre%20color%2C%20beautifully%20defined%20lip%20contour%20and%20shape%2C%20clean%20white%20studio%20background%2C%20professional%20Korean%20beauty%20clinic%20photography%2C%20soft%20elegant%20lighting%2C%20natural%20youthful%20dewy%20finish&width=400&height=500&seq=gallery_lip1_v2&orientation=portrait',
  },
  {
    id: 5,
    category: '두피 반영구 문신',
    title: '헤어라인 교정',
    image: 'https://readdy.ai/api/search-image?query=close-up%20of%20Korean%20man%20forehead%20and%20hairline%20area%20showing%20scalp%20micropigmentation%20SMP%20hairline%20restoration%20result%2C%20natural-looking%20defined%20hairline%20with%20precise%20fine%20pigment%20dots%2C%20clean%20bright%20studio%20background%2C%20professional%20Korean%20aesthetic%20clinic%20photography%2C%20realistic%20and%20natural%20hairline%20correction&width=400&height=500&seq=gallery_smp2_v2&orientation=portrait',
  },
  {
    id: 6,
    category: '입술 반영구 문신',
    title: '풀립 컬러',
    image: 'https://readdy.ai/api/search-image?query=close-up%20of%20Korean%20woman%20lips%20showing%20full%20lip%20semi-permanent%20tattoo%20result%20with%20vivid%20natural%20coral%20pink%20tone%20evenly%20saturated%20across%20full%20lips%2C%20perfectly%20shaped%20plump%20lips%20with%20defined%20cupids%20bow%2C%20clean%20white%20studio%20background%2C%20professional%20Korean%20beauty%20clinic%20photography%2C%20elegant%20soft%20beauty%20lighting&width=400&height=500&seq=gallery_lip2_v2&orientation=portrait',
  },
];
